import { defineComponent as d, useSlots as r, unref as t, openBlock as l, createBlock as a, withCtx as s, renderSlot as o } from "vue";
import i from "./ghl-ui.es320.js";
const f = d({
  name: "UIDivider",
  inheritAttrs: !1
}), m = d({
  ...f,
  props: {
    titlePlacement: {
      type: String,
      default: "center"
    },
    dashed: {
      type: Boolean,
      default: !1
    },
    vertical: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const n = r();
    return (c, u) => t(n).default ? (l(), a(t(i), {
      key: 0,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical
    }, {
      default: s(() => [
        o(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["title-placement", "dashed", "vertical"])) : (l(), a(t(i), {
      key: 1,
      "title-placement": e.titlePlacement,
      dashed: e.dashed,
      vertical: e.vertical
    }, null, 8, ["title-placement", "dashed", "vertical"]));
  }
}), p = m;
export {
  p as default
};
